import produce, { Draft } from 'immer';
import { keyBy } from 'lodash';

// Actions
import DropdownReduxActions from 'app/shared/dropdown/actions';

// Models
import { DropdownState, DropdownActionTypes } from 'app/shared/dropdown/models';

export const initialState: DropdownState = {
  agents: {},
  orgs: {},
  units: {},
};

type ReduxActions = DropdownReduxActions;

const reducer = (state = initialState, action: ReduxActions) => {
  return produce(state, (draft: Draft<DropdownState>) => {
    switch (action.type) {
      case DropdownActionTypes.RETRIEVE_DROPDOWN_AGENTS_SUCCESS:
        draft.agents = {
          ...draft.agents,
          ...keyBy(action.payload.agents, (agent) => agent.id),
        };
        return;

      case DropdownActionTypes.RETRIEVE_DROPDOWN_ORGS_SUCCESS:
        draft.orgs = {
          ...draft.orgs,
          ...keyBy(action.payload.results, (org) => org.id),
        };
        return;
    }
  });
};

export { reducer as dropdownReducer };
